export const URLRedirect = {
    exitRedirect: 'https://www.bancolombia.com/tramites-digitales/firma-electronica-seguros'
}